// extracted by mini-css-extract-plugin
export default {"newsAndSlider":"index_newsAndSlider_2MjW7"};